// extracted by mini-css-extract-plugin
export var products = "products-module--products--12lKk";
export var highlight = "products-module--highlight--3BQT0";
export var header = "products-module--header--yCP65";
export var content = "products-module--content--2DZwz";
export var product = "products-module--product--ZhvHe";
export var description = "products-module--description--1T4ac";
export var more = "products-module--more--2gB6G";